module.exports = __webpack_public_path__ + "static/media/L1.a8324121.svg";